<template>
 <div class="tw:h-screen tw:w-full tw:p-0 tw:m-0">
  <slot></slot>

 </div>
</template>
